/* SASKSTORE — fiche lunettes v2 : ordonnance / puissance, bascule galerie Produit/Porté, garde-fou sticky. */
(function () {
  'use strict';

  class SaskOrdonnance extends HTMLElement {
    connectedCallback() {
      this.pos = parseInt(this.dataset.optionPosition, 10);
      this.formId = this.dataset.formId;
      this.erreur = this.querySelector('.sask-ordo__erreur');
      this.setMode(this.dataset.mode || '');
      this.addEventListener('change', (e) => {
        if (e.target.matches('[data-sask-choix]')) this.majChoix();
        this.cacherErreur();
      });
      // Changement de variante (pastilles Dawn) : lecture directe de l'input coché.
      document.addEventListener('change', (e) => {
        const t = e.target;
        if (!t.closest || !t.closest('variant-selects')) return;
        if (t.name && t.name.endsWith('-' + this.pos)) this.setMode(this.modeDepuis(t.value));
      });
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, (ev) => {
          const v = ev && ev.data && ev.data.variant;
          if (v && v.options) this.setMode(this.modeDepuis(v.options[this.pos - 1]));
        });
      }
      // Garde-fou au clic (phase de capture sur window, avant les scripts d'apps comme EasySell) :
      // bouton Ajouter au panier, bouton de la barre sticky et bouton d'envoi du formulaire EasySell.
      window.addEventListener('click', (e) => {
        if (!this.mode) return;
        const btn = e.target.closest && e.target.closest('button, input[type="submit"]');
        if (!btn) return;
        // NB : form.id renverrait l'input name="id" (variante) — on lit donc l'attribut.
        const cibleForm = (btn.form && btn.form.getAttribute('id') === this.formId) || btn.getAttribute('form') === this.formId;
        const easySell = !!(btn.closest('#es-form') && btn.matches('#es-form-button, .es-cta-btn, [type="submit"]'));
        if (!cibleForm && !easySell) return;
        if (btn.type !== 'submit' && !easySell) return;
        if (!this.valider()) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      }, true);
      // Garde-fou : bloque l'ajout au panier (bouton principal ET barre sticky) si les champs requis manquent.
      document.addEventListener('submit', (e) => {
        if (!e.target || !e.target.getAttribute || e.target.getAttribute('id') !== this.formId) return;
        if (!this.valider()) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      }, true);
    }
    modeDepuis(val) {
      const v = (val || '').toLowerCase();
      if (v.includes('lecture')) return 'lecture';
      if (v.includes('correct')) return 'correcteur';
      return '';
    }
    activer(el, on) {
      el.hidden = !on;
      el.querySelectorAll('input, select, textarea').forEach((i) => { i.disabled = !on; });
    }
    setMode(mode) {
      this.mode = mode;
      this.dataset.mode = mode;
      this.querySelectorAll('[data-sask-mode]').forEach((p) => this.activer(p, p.dataset.saskMode === mode));
      if (mode === 'correcteur') this.majChoix();
      this.cacherErreur();
    }
    choix() {
      const r = this.querySelector('[data-sask-choix]:checked');
      return r ? r.dataset.saskChoix : 'apres';
    }
    majChoix() {
      if (this.mode !== 'correcteur') return;
      const c = this.choix();
      this.querySelectorAll('[data-sask-si]').forEach((b) => {
        const on = b.dataset.saskSi === c;
        b.hidden = !on;
        b.querySelectorAll('input, select, textarea').forEach((i) => { i.disabled = !on; });
      });
    }
    valider() {
      let msg = '';
      let cible = null;
      if (this.mode === 'lecture') {
        const f = this.querySelector('[data-sask-mode="lecture"] input, [data-sask-mode="lecture"] select');
        if (f && !f.value.trim()) { msg = this.dataset.errLecture; cible = f; }
      } else if (this.mode === 'correcteur') {
        const c = this.choix();
        if (c === 'saisie') {
          const sph = Array.from(this.querySelectorAll('[data-sask-si="saisie"] [data-sask-requis]'));
          const vide = sph.find((i) => !i.value.trim());
          if (vide) { msg = this.dataset.errSaisie; cible = vide; }
        } else if (c === 'photo') {
          const f = this.querySelector('[data-sask-si="photo"] input[type="file"]');
          if (f && !f.files.length) { msg = this.dataset.errPhoto; cible = f; }
        }
      }
      if (msg) {
        this.erreur.textContent = msg;
        this.erreur.hidden = false;
        const y = this.getBoundingClientRect().top + window.scrollY - 90;
        window.scrollTo({ top: y, behavior: 'smooth' });
        setTimeout(() => cible && cible.focus({ preventScroll: true }), 400);
        return false;
      }
      return true;
    }
    cacherErreur() { if (this.erreur) this.erreur.hidden = true; }
  }
  if (!customElements.get('sask-ordonnance')) customElements.define('sask-ordonnance', SaskOrdonnance);

  // Bascule Produit / Porté
  document.addEventListener('click', (e) => {
    const btn = e.target.closest && e.target.closest('.sask-bascule__btn');
    if (!btn) return;
    const wrap = btn.closest('.sask-bascule');
    const ids = (wrap.dataset.saskPortees || '').split(',').filter(Boolean);
    const gal = document.getElementById(wrap.dataset.gallery);
    if (!gal) return;
    const vue = btn.dataset.saskVue;
    wrap.querySelectorAll('.sask-bascule__btn').forEach((b) => {
      const on = b === btn;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    let premier = null;
    gal.querySelectorAll('.product__media-list > li[data-media-id]').forEach((li) => {
      const porte = ids.includes(li.dataset.mediaId);
      const visible = vue === 'porte' ? porte : !porte;
      li.style.display = visible ? '' : 'none';
      if (visible && !premier) premier = li;
    });
    const slider = gal.querySelector('slider-component');
    if (slider && typeof slider.resetPages === 'function') slider.resetPages();
    if (premier && premier.parentElement) premier.parentElement.scrollTo({ left: 0 });
  });
})();

// Barre sticky : ligne « verre choisi » mise à jour au changement de variante.
document.addEventListener('DOMContentLoaded', () => {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  subscribe(PUB_SUB_EVENTS.variantChange, (ev) => {
    const v = ev && ev.data && ev.data.variant;
    if (!v) return;
    document.querySelectorAll('[data-sask-sticky-verre]').forEach((el) => { el.textContent = v.title; });
  });
});
